import { __assign } from "tslib";
import React, { Fragment } from 'react';
import { IconSVG } from '../icon-svg/icon-svg';
export var IconChevronUp = function (SVGprops) {
    return (React.createElement(IconSVG, __assign({}, SVGprops),
        React.createElement(Fragment, null,
            React.createElement("path", { d: "m19.293 16.7071-7.293-7.29304-7.29303 7.29304-1.414-1.414 8.70703-8.70704 8.707 8.70704z" }))));
};
